/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/**
 * AddThis Social Sharing
 * configuration and initialization
 */

define('modules/AddThis/AddThisLoader',[
    'jquery',
    'global/all'],
    function ($, Roc) {
        'use strict';

        // Configuration settings for AddThis
        window.addthis_config = window.addthis_config || {};
        window.addthis_config = {
            username: 'ameaglecom',
            ui_click: true,
            ui_508_compliant: true,
            ui_cobrand: 'AmericanEagle.com',
            services_exclude: 'print,email,gmail'
        };

        function addThisLoader() {
            $(document).ready(function () {
                // Fixes .NET issue with config attributes
                $('.addthis_button_google_plusone').attr('g:plusone:count', 'false');
                /* $('.addthis_button_facebook_like').attr("fb:like:layout", "button_count"); */
            });

            // Loads external js resource from AddThis and caches the script
            // pubid should be replaced with account id for site
            Roc.Core.cachedScript('//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-58d163b3ce844bae')
            .done(function (script, textStatus) {
                $(function () {
                    if (typeof (window.addthis) !== 'undefined') {
                        window.addthis.init();
                    }
                });
            });
        };

        // init the AddThis loader
        //addThisLoader();
    });
